var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gap-3 mb-4 lg:w-full mr-2 item-card"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }